import PropTypes from 'prop-types'
import { logbook7DaysRulePropType } from '../logbook/logbook-seven-days-rule-prop-type'

/**
 * @typedef {Object} TripRules
 *
 * @property {number} [logbook7DaysRule] - config for the 7 day rule
 */

export const tripRulesPropType = PropTypes.shape({
    logbook7DaysRule: logbook7DaysRulePropType
})
